/**
 * DOM utility functions
 */

/**
 * Blurs the currently focused element if one exists.
 * Useful for cleaning up focus state when closing modals or dialogs.
 */
export function blurActiveElement(): void {
  if (document && document.activeElement && document.activeElement instanceof HTMLElement) {
    document.activeElement.blur();
  }
}
